var modules_39642e22 = {"bubble":"Tooltip_module_bubble__b73e0b30","arrow":"Tooltip_module_arrow__b73e0b30","container":"Tooltip_module_container__b73e0b30","close":"Tooltip_module_close__b73e0b30","outline-none":"Tooltip_module_outlineNone__b73e0b30"};
import "../../../assets/esm/components/Tooltip/src/Tooltip~BG4xXidZ.css";

export { modules_39642e22 as default };
//# sourceMappingURL=Tooltip.module.less.js.map
